export default {
  'primary': '#0525A4',
  'secondary': '#00D6BD',
  'accent': '#0525A4'
}
